export const TextDecoder = globalThis.TextDecoder;
export const TextEncoder = globalThis.TextEncoder;
